import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApplicationSetting } from '../models';
import { BaseEditService } from './base';
import { BooleanStrings } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class ApplicationSettingService extends BaseEditService<ApplicationSetting, ApplicationSetting> {
  constructor() {
    super('ApplicationSetting', $localize`Application Setting`);
  }

  get(key: string): Observable<string> {
    return this.httpService
      .get<ApplicationSetting>(`${this.apiUrl}?key=${key}`)
      .pipe(map((applicationSetting: ApplicationSetting) => applicationSetting?.value));
  }

  getBoolean(key: string): Observable<boolean> {
    return this.get(key).pipe(map((result) => result?.toUpperCase() === BooleanStrings.yes.toUpperCase()));
  }

  /**
   * A numeric setting, or 0 when it is absent or not a number. Note 0 means "no
   * value here" — the API owns each setting's real default (GetOrCreateInt), so a
   * caller should treat 0 as "leave it to the server" rather than restate it.
   */
  getNumber(key: string): Observable<number> {
    return this.get(key).pipe(map((result) => Number(result) || 0));
  }
}
